import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'

const getTranslateMasterFilters = function () {
  return {
    id: { label: i18n.t('app.id'), value: '' },
    name: { label: i18n.t('app.name'), value: '' },
    tipoGrupo: { label: i18n.t('app.type'), value: '' },
    enUso: { label: i18n.t('app.in_use'), value: '' },
    verTodoGroups: { label: i18n.t('configurations.ver_todo_groups'), value: '' },
    verTodoStatuses: { label: i18n.t('configurations.ver_todo_statuses'), value: '' },
    verTodoCompanies: { label: i18n.t('configurations.ver_todo_companies'), value: '' },
    send_alerts: { label: i18n.t('app.send_alerts'), value: '' },
    email: { label: i18n.tc('users.email', 1), value: '' },
  }
}
const getColumns = function getColumns () {
  return [
    { field: 'Propietario', title: i18n.t('groups.owner'), columnMenu: 'myTemplate', width: '150px', locked: false, cell: 'checkboxTemplate' },
    { field: 'IdGrupo', width: '100px', title: i18n.t('app.id'), hidden: true, columnMenu: 'myTemplate', locked: false },
    { field: 'Nombre', width: '250px', title: i18n.t('app.name'), columnMenu: 'myTemplate', locked: false },
    { field: 'idTipo', width: '200px', title: i18n.t('app.type'), columnMenu: 'myTemplate', cell: 'enumTemplate', format: 'TIPOS_GRUPO', locked: false },
    { field: 'Usuarios', width: '440px', title: i18n.t('users.header'), columnMenu: 'myTemplate', locked: false, cell: 'tagsTemplate', sortable: false, groupable: false },
    { field: 'VerTodoGrupos', width: '225px', title: i18n.t('configurations.ver_todo_groups'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
    { field: 'VerTodoEstados', width: '225px', title: i18n.t('configurations.ver_todo_statuses'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
    { field: 'VerTodoEmpresas', width: '225px', title: i18n.t('configurations.ver_todo_companies'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
    { 
      field: 'idCliente', 
      title: i18n.t('clients.id_client'), 
      hidden: true, 
      columnMenu: 'myTemplate', 
      width: '150px', 
      locked: false,
      only: {
        roles: [7, 8, 3],
      }, 
    },
  ] 
}
const mystore = parent({ selectable: true, navigate: false, namespaced: true, getTranslateColumns: getColumns, getTranslateMasterFilters })

export default mystore
